export const IPAD_PORTRAIT_BREAKPOINT = {
  minWidth: 600,
  maxWidth: 960,
};

export const IPAD_LANDSCAPE_BREAKPOINT = {
  minWidth: 950,
  maxWidth: 1170,
};

const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
    custom: 600,
    landScape: IPAD_LANDSCAPE_BREAKPOINT,
    ipadPortrait: IPAD_PORTRAIT_BREAKPOINT,
  },
};

export default breakpoints;
